import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;

  position: sticky;
  top: -1px;

  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease,
    transform 0.3s ease,
    opacity 0.3s ease;

  &.is-stuck {
    background: var(--mode-bg-neutral-weakest, var(--snow));
    padding: 16px;
    border-radius: 8px;
    z-index: 1;
    box-shadow: 0px 6px 24px 0px
      var(--mode-shadow-default, rgba(186, 192, 201, 0.4));
    transform: translateY(0);
    .last-updated-container {
      display: none;
    }
  }
`;

export const Heading = styled(Typography.Title)`
  margin-bottom: 3px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const TimeframeColumn = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
`;
